import axiosInstance from "@/api/axios";

export default {
  namespaced: true,
  state: {
    agencyCounts: [],
    companyCounts: [],
    adsCounts: [],
    needsCounts: [],
    eventCounts: [],
    agencyGraph: [],
    needGraph: [],
    eventGraph: [],
    volunteersGraph: [],
    allAdmins:[]
  },
  getters: {
    getAgencyCount(state) {
      return state.agencyCounts;
    },
    getCompanyCount(state) {
      return state.companyCounts;
    },
    getAdsCount(state) {
      return state.adsCounts;
    },
    getNeedsCount(state) {
      return state.needsCounts;
    },
    getEventCount(state) {
      return state.eventCounts;
    },
    agencyGraphData(state) {
      return state.agencyGraph;
    },
    needGraphData(state) {
      return state.needGraph;
    },
    eventGraphData(state) {
      return state.eventGraph;
    },
    volunteersGraphData(state) {
      return state.volunteersGraph;
    },
    fetchAllAdmins(state){
      return state.allAdmins;
    }
  },
  mutations: {
    setAgencyCount(state, data) {
      state.agencyCounts = data;
    },
    setCompanyCount(state, data) {
      state.companyCounts = data;
    },
    setAdsCount(state, data) {
      state.adsCounts = data;
    },
    setNeedsCount(state, data) {
      state.needsCounts = data;
    },
    setEventCount(state, data) {
      state.eventCounts = data;
    },
    agencyGraph(state, data) {
      state.agencyGraph = data;
    },
    needGraph(state, data) {
      state.needGraph = data;
    },
    eventGraph(state, data) {
      state.eventGraph = data;
    },
    volunteersGraph(state, data) {
      state.volunteersGraph = data;
    },
    setAllAdmin(state, data) {
      state.allAdmins = data;
    },
        addAdmin(state, admin) {
      state.allAdmins.push(admin);
    },
    updateAdmin(state, updatedAdmin) {
      const index = state.allAdmins.findIndex(a => a._id === updatedAdmin._id);
      if (index !== -1) {
        state.allAdmins.splice(index, 1, updatedAdmin);
      }
    },
deleteAdmin(state, adminId) {
  state.allAdmins = state.allAdmins.filter(a => a._id !== adminId);
}
  },
  actions: {
    fetchAgencyCountDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getAgencyDetails")
          .then(res => {
            if (res.data.success) {
              commit("setAgencyCount", res.data.res);
              resolve(res.data.res);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchCompanyCountDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getCompanyDetails")
          .then(res => {
            if (res.data.success) {
              commit("setCompanyCount", res.data.res);
              resolve(res.data.res);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAdsCountDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getAdsStatistics")
          .then(res => {
            if (res.data.success) {
              commit("setAdsCount", res.data.res);
              resolve(res.data.res);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchNeedCountDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getNeedsStatistics")
          .then(res => {
            if (res.data.success) {
              commit("setNeedsCount", res.data.res);
              resolve(res.data.res);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            console.error('=== Error fetching needs statistics ===', error);
            reject(error);
          });
      });
    },
    fetchEventCountDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getEventStatistics")
          .then(res => {
            if (res.data.success) {
              commit("setEventCount", res.data.res);
              resolve(res.data.res);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAgencyGraphDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getAgencyGraph")
          .then(res => {
            if (res.data.success) {
              commit("agencyGraph", res.data.data);
              resolve(res.data.data);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchNeedGraphDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getNeedsGraph")
          .then(res => {
            if (res.data.success) {
              commit("needGraph", res.data.data);
              resolve(res.data.data);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            console.error('=== Error fetching needs graph ===', error);
            reject(error);
          });
      });
    },
    fetchEventGraphDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getEventsGraph")
          .then(res => {
            if (res.data.success) {
              commit("eventGraph", res.data.data);
              resolve(res.data.data);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchVolunteersGraphDetails({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/getVolunteersGraph")
          .then(res => {
            if (res.data.success) {
              commit("volunteersGraph", res.data.data);
              resolve(res.data.data);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
      getAllAdmins({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/all")
          .then(res => {
            if (res.data.success) {
              commit("setAllAdmin", res.data.admins);
              resolve(res.data.data);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createAdmin({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/create", payload)
          .then(res => {
            if (res.data.success) {
              commit("addAdmin", res.data.admin);
              resolve(res.data.admin);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => reject(error));
      });
    },

    editAdmin({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("admin/update", payload)
          .then(res => {
            if (res.data.success) {
              commit("updateAdmin", res.data.admin);
              resolve(res.data.admin);
            } else {
              reject(new Error(res.data.message));
            }
          })
          .catch(error => reject(error));
      });
    },
deleteAdmin({ commit, rootState }, payload) {
  return new Promise((resolve, reject) => {
    axiosInstance(rootState.auth.token)
      .post("admin/delete", payload)
      .then(res => {
        if (res.data.success) {
          // commit the correct mutation with the deleted admin's ID
          commit("deleteAdmin", payload.id);
          resolve(res.data.admin);
        } else {
          reject(new Error(res.data.message));
        }
      })
      .catch(error => reject(error));
  });
}


  }
};
